import ModalForm from 'components/commons/modal-form'
import { Button, InlineError, Input } from 'avo-ui'
import icKey from 'assets/images/ic-key.svg'

export const FormChangePassword = ({
    show,
    newPassword,
    errorForm,
    onHideForm,
    onGenerate,
    onChangeForm,
    isLoading,
    onSubmit,
}) => {
    return (
        <ModalForm
            className={'!w-[500px]'}
            show={show}
            onHide={onHideForm}
            title={'Change Password'}
            isLoading={isLoading}
            onSubmit={onSubmit}
        >
            <div className={'flex flex-col space-y-3 px-8 py-2 mb-2'}>
                <div className={'font-semibold text-blue-90 required'}>Password Baru</div>
                <div className={'flex space-x-3'}>
                    <Input
                        className={'flex-1'}
                        name={'new_password'}
                        placeholder={'Masukkan Password Baru'}
                        type={'password'}
                        value={newPassword}
                        onChange={(item) => onChangeForm(item?.value)}
                    />
                    <Button title={'Generate Password'} icon={icKey} onClick={onGenerate} />
                </div>
                <InlineError className='mt-2' message={errorForm} />
            </div>
        </ModalForm>
    )
}
